import {Component, Inject, OnInit} from '@angular/core';
import {CustomerModel} from '../../../order-to-cash/models-otc/customer-model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import { BasicLabManagerItemModel } from 'src/app/models/lab-manager/basic-lab-manager-item';
import { User } from 'src/app/models/user';

@Component({
    selector: 'app-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['./filter-dialog.component.css'],
    standalone: false
})
export class FilterDialogComponent implements OnInit{

  customerList: CustomerModel[] = [];
  selectedClientId: number = null;
  labAgentList: User[] = [];
  selectedLabAgentId: number = null;
  startDate: string;
  endDate: string;
  filterCustomerList: CustomerModel[] = [];
  statusList: BasicLabManagerItemModel[] = [];
  selectedStatusIds: number[] = [];
  clientFilterCtrl: FormControl = new FormControl();
  submissionTypes: BasicLabManagerItemModel[] = [];
  selectedSubmissionType: number = null;
  recManTypes: any[] = [];
  selectedRecManTypeId: number = null;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<FilterDialogComponent>,
  ) {
    this.clientFilterCtrl.valueChanges.subscribe({
      next: res => {
        this.filterCustomerList = [...this.customerList.filter(c => c?.name?.toLowerCase().includes(res.toLowerCase()))];
      }
    })
  }

  ngOnInit() {
    this.customerList = this.data.customerList;
    this.filterCustomerList = [...this.customerList];
    this.selectedClientId = this.data?.selectedClientId ?? null;
    this.startDate = this.data?.startDate ?? null;
    this.endDate = this.data?.endDate ?? null;
    this.statusList = this.data?.statusList ?? null;
    this.selectedStatusIds = this.data?.selectedStatusIds ?? null;
    this.selectedLabAgentId = this.data?.selectedLabAgentId ?? null;
    this.labAgentList = this.data?.labAgentList ?? null;
    this.submissionTypes = this.data?.submissionTypes ?? null;
    this.selectedSubmissionType = this.data?.selectedSubmissionType ?? null;
    this.recManTypes = this.data?.recManTypes ?? [];
  }

  closeDialog(cancelClicked: boolean) {
    let filter = null;

    if(!cancelClicked) {

      filter = {
        selectedClientId: this.selectedClientId,
        startDate: this.startDate,
        endDate: this.endDate,
        selectedStatusIds: this.selectedStatusIds,
        selectedLabAgentId: this.selectedLabAgentId,
        selectedSubmissionType: this.selectedSubmissionType,
        selectedRecManTypeId: this.selectedRecManTypeId
      }
    }

    this.dialogRef.close(filter);
  }

}
